export const INDIVIDUALS_MODULE_ID = 2;